import React from 'react'
import AccountInvitationPanel from '../AccountInvitationPanel'
import { runClubCommand, clubInvitationLabels } from './clubCreationOperation'

export default function ClubInvitationPanel(props) {
  return <AccountInvitationPanel {...props} resource="club" accountName="Owner" labels={clubInvitationLabels} runCommand={runClubCommand} />
}
